import { Box } from '@spark-web/box';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { ThemeProvider } from '@spark-web/theme';
import { useQueryState } from 'nuqs';

import { usePartnerConfig } from '~/context/PartnerConfigContext';
import { usePartner } from '~/hooks/usePartner';
import { parseAsMarketplaceChannel } from '~/utils/channels';
import { toSparkTheme } from '~/utils/theme';

import ErrorImage from '../assets/error.svg';

import { HeaderLogos } from './header-logos';

type MaintenanceLayoutProps = {
  endDate?: string; // ISO string
};

export const MaintenanceLayout = ({ endDate: endDateStr }: MaintenanceLayoutProps) => {
  const [channel] = useQueryState('channel', parseAsMarketplaceChannel.withDefault('brighte'));
  const config = usePartnerConfig();
  const partner = usePartner();

  const theme = toSparkTheme(config?.configuration?.sparkThemeName);
  const endDate = endDateStr ? new Date(endDateStr) : null;

  return (
    <ThemeProvider theme={theme}>
      {/* We can't set the meta export function so thanks to React v19 we can do this instead */}
      <title>We&apos;ll be right back! - Brighte Marketplace</title>
      <Box
        display="flex"
        alignItems="center"
        justifyContent={{ tablet: 'center' }}
        height="full"
        width="full"
        padding="xlarge"
      >
        <Stack gap="xlarge">
          <HeaderLogos channel={channel} partner={partner} />
          <Stack align="left" gap="xlarge">
            <img src={ErrorImage} alt="error" />
          </Stack>
          <Text>
            We&apos;ll be back in a bit. We are currently undergoing maintenance to ensure you get the best application
            experience.
          </Text>
          {endDate && (
            <Text>
              The maintenance is expected to run until{' '}
              {endDate.toLocaleString('en-AU', {
                dateStyle: 'long',
                timeStyle: 'short',
              })}
              .
            </Text>
          )}
          <Text>Thank you for your patience and understanding.</Text>
          <Text>Brighte Team</Text>
        </Stack>
      </Box>
    </ThemeProvider>
  );
};
